import React from 'react';
import { FormControl, FormLabel, RadioGroup as MuiRadioGroup, FormControlLabel, Radio, createTheme, MuiThemeProvider } from '@material-ui/core';

const styles = () => ({
  title: {
    fontSize: '15px',
    lineHeight: '5px',
    fontFamily: 'canalfont-bold',
    fontWeight: '300',
    marginBottom: '5px',
    letterSpacing: '0.15px',
    color: 'black',
  },
  container: {
    height: '60px',
    padding: '15px',
  },
});
const theme = createTheme({
  palette: {
    primary: {
      main: '#6200EE',
    },
    secondary: {
      main: '#6200EE',
    },
  },
});

export default function RadioGroup(props) {
  const { name, label, value, onChange, items = [] } = props;
  const classes = styles();
  return (
    <div>
      <MuiThemeProvider theme={theme}>
        <FormControl style={classes.container}>
          <FormLabel style={classes.title}>{label}</FormLabel>
          <MuiRadioGroup row name={name} value={value} onChange={onChange}>
            {items?.map((item) => (
              <FormControlLabel key={item.id} value={item.id} label={item.title} control={<Radio />} />
            ))}
          </MuiRadioGroup>
        </FormControl>
      </MuiThemeProvider>
    </div>
  );
}
